(function () {
    'use strict';
    angular
        .module('moldovaYieldCurvesApp')
        .factory('ObservedDataCsv', ObservedDataCsv);

    ObservedDataCsv.$inject = ['$resource'];

    function ObservedDataCsv($resource) {
        var resourceUrl = 'api/observed-data/csv';

        return function (exportType) {
                return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        responseType: "text",
                        transformResponse: function (data, headers) {
                            var response = {};
                            response.data = data;
                            response.headers = headers();
                            return response;
                        }
                    }
                });
        }
    }
})();
